import { Target, ListOrdered } from "lucide-react";
import { TopScorers } from "@/components/football/TopScorers";

export const SECTIONS = [["scores", "Scores", ListOrdered], ["scorers", "Top Scorers", Target]];

export const SectionTabs = ({ sec, setSec }) => (
  <div className="flex gap-2 overflow-x-auto pb-1 mb-5" data-testid="fb-sections">
    {SECTIONS.map(([k, l, I]) => (
      <button key={k} onClick={() => setSec(k)} data-testid={`fb-sec-${k}`} aria-pressed={sec === k}
        className={`h-10 px-4 rounded-full text-sm font-bold inline-flex items-center gap-1.5 whitespace-nowrap border transition-colors ${sec === k ? "bg-[#E11D2A] border-[#E11D2A] text-white" : "bg-[#121620] border-[#273042] text-slate-300 hover:text-white"}`}>
        <I className="w-4 h-4" />{l}
      </button>))}
  </div>
);

export function SbSections({ sec }) {
  return <div data-testid={`fb-sec-${sec}-content`}>{sec === "scorers" && <TopScorers />}</div>;
}
